export default "__VITE_ASSET__Cw6NiAEo__"